"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryProxy = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const isListResult = (data) => {
    return (typeof data === 'object' &&
        data !== null &&
        data.hasOwnProperty('items') &&
        Array.isArray(data.items) &&
        typeof data.totalCount === 'number');
};
class MemoryProxy {
    constructor(config) {
        this.config = config;
        this.params = {};
    }
    load(payload, loadParams, loadFilterQuery) {
        const params = Object.assign(Object.assign({}, this.params), (loadParams || {}));
        return (0, rxjs_1.of)(this.dataProvider ? this.dataProvider(params) : null).pipe((0, operators_1.map)((data) => {
            if (!data) {
                return {
                    meta: {
                        status: 200
                    },
                    data: null
                };
            }
            let resultData = data;
            if (isListResult(resultData)) {
                resultData = resultData.items;
            }
            return {
                meta: {
                    status: 200
                },
                data: this.config.mapper(resultData)
            };
        }));
    }
    setContext() {
        // no-op
    }
    /**
     * Set data provider
     * @param dataProvider
     */
    setDataProvider(dataProvider) {
        this.dataProvider = dataProvider;
    }
    setParams(params) {
        this.params = params;
    }
    isEmpty(data) {
        return data == null || data === '' || (Array.isArray(data) && !data.length);
    }
}
exports.MemoryProxy = MemoryProxy;
//# sourceMappingURL=MemoryProxy.js.map